import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Styles
import styles from './Subheading.styl';

const cx = classNames.bind(styles);

export default function Subheading(props) {
  const { className, children, text, big, ...otherProps } = props;

  const cn = cx('Subheading', className, { Subheading_big: big });

  if (text) {
    return <div {...otherProps} className={cn} dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return (
    <div {...otherProps} className={cn}>
      {children}
    </div>
  );
}

Subheading.defaultProps = {
  className: '',
  children: '',
  text: '',
  big: false,
};

Subheading.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  text: PropTypes.any,
  big: PropTypes.bool,
};
